import styles from './style.module.css';
export const ReferencePageTitle = ({title}: {title: string}) => {
  return (
    <div className={styles.title}>
      <h2>{title}</h2>
    </div>
  );
};
